import React from 'react'
import loadable from '@loadable/component'
import InfoIcon from '@/assets/icons/info.svg'
import { ListWithTooltipTypes } from './types'
import * as styles from './ListWithTooltip.module.css'

const Tooltip = loadable(() =>
  import('react-tooltip').then((module) => ({
    default: module.Tooltip
  }))
)

export function ListWithTooltip({ list_items }: ListWithTooltipTypes) {
  return (
    <div className="flex flex-col w-1/3">
      {list_items?.length &&
        list_items.map((item) => (
          <>
            <span className="font-poppins font-bold text-lg h-80 px-32 flex items-center">{item.title}</span>
            {item.text_items?.map((itemText) => (
              <div key={itemText._uid} className={styles.list}>
                <div className="flex items-center h-80 px-32 relative">
                  {itemText.text.length > 0 && (
                    <img
                      data-tooltip-id={`tip${itemText._uid}`}
                      src={InfoIcon}
                      alt="tooltip"
                      className="h-20 absolute -left-32"
                    />
                  )}
                </div>
                <Tooltip id={`tip${itemText._uid}`} style={{ background: '#6676D6', color: '#FFF' }} place="top">
                  <span className="relative">{itemText.text?.length > 0 ? itemText.text : ''}</span>
                </Tooltip>
              </div>
            ))}
          </>
        ))}
    </div>
  )
}
